module.exports = __webpack_public_path__ + "static/media/emblem0.f85c4ad3.jpeg";